export default __webpack_public_path__ + "images/899c51644d49a1cc4a818f2b38e48ca5.svg";